// @ts-nocheck
import {create} from "zustand";

const useContactStore = create((set, get) => ({
  emailContact: null,
  contact: null,
  contacts: [],
  setContacts: contacts => set({contacts}),
  setMyContacts: contacts => set({myContacts: contacts}),
  setEmailContact: ({email}) => {
    set({emailContact: email});
  },
  findContact: id => {
    if (id) {
      const contacts = get().contacts;
      const contact = contacts.find(item => item.contact_id === id);
      return contact;
    }
    return null;
  },
  filterContacts: text => {
    const contacts = get().myContacts;
    if (text) {
      const filteredContacts = contacts.filter(item => item.name.toLowerCase().includes(text.toLowerCase()));
      return set({contacts: filteredContacts});
    }
    set({contacts: contacts});
  },
}));

export default useContactStore;
